import { captureAttribution } from './attribution';

export async function getClientMetadata(): Promise<any> {
    // 1. Get IP and geolocation via API
    const ipRes = await fetch("https://ipapi.co/json/");
    const ipData = await ipRes.json();

    // 2. Get browser info
    const userAgent = navigator.userAgent;
    const languages = navigator.languages;
    const referrer = document.referrer;
    const currentUrl = window.location.href;
    const pageTitle = document.title;
    const timestamp = new Date().toISOString();

    const detectPlatform = () => {
        if (/Windows NT/i.test(userAgent)) return "Windows";
        if (/Macintosh/i.test(userAgent)) return "macOS";
        if (/Linux/i.test(userAgent)) return "Linux";
        if (/Android/i.test(userAgent)) return "Android";
        if (/iPhone|iPad|iPod/i.test(userAgent)) return "iOS";
        return "Unknown";
    };

    const detectIsMobile = () => /Mobi|Android|iPhone|iPad|iPod/i.test(userAgent);

    const clientHints = {
        uaPlatform: navigator.userAgentData?.platform || navigator.platform || detectPlatform(),
        isMobile: navigator.userAgentData?.mobile ?? detectIsMobile(),
        brands: navigator.userAgentData?.brands || []
    };
    // 4. Optional screen data
    const screenData = {
        width: window.screen.width,
        height: window.screen.height,
        pixelDepth: window.screen.pixelDepth
    };

    // 5. Get GA4 attribution data (includes client_id for session continuity)
    const attribution = await captureAttribution();

    // 6. Build payload with attribution merged in
    return {
        timestamp,
        ip_address: ipData.ip,
        geo: {
            country: ipData.country_name,
            region: ipData.region,
            city: ipData.city,
            latitude: ipData.latitude,
            longitude: ipData.longitude,
            timezone: ipData.timezone,
            org: ipData.org
        },
        browser: {
            userAgent,
            languages,
            clientHints,
            screen: screenData
        },
        referrer,
        currentUrl,
        pageTitle,
        // Include GA4 attribution for backend Measurement Protocol events
        ...attribution
    };
}
